"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var SignupAction;
(function (SignupAction) {
    SignupAction.ON_SIGNUP_SUBMIT = 'ON_SIGNUP_SUBMIT';
    SignupAction.ON_SIGNUP_CLOSE_CLICK = 'ON_SIGNUP_CLOSE_CLICK';
    SignupAction.ON_SIGNUP_LOGIN_CLICK = 'ON_SIGNUP_LOGIN_CLICK';
    SignupAction.TOGGLE_SINGUP_PANEL_ACTIVE = 'TOGGLE_SINGUP_PANEL_ACTIVE';
    SignupAction.SET_SINGUP_PANEL_ACTIVE = 'SET_SINGUP_PANEL_ACTIVE';
    SignupAction.SET_SINGUP_PANEL_DIM = 'SET_SINGUP_PANEL_DIM';
    SignupAction.SET_SIGNUP_LOADING = 'SET_SIGNUP_LOADING';
    SignupAction.SET_SIGNUP_GLOBAL_ERROR = 'SET_SIGNUP_GLOBAL_ERROR';
    SignupAction.onSignupSubmit = typesafe_actions_1.createAction(SignupAction.ON_SIGNUP_SUBMIT, function (resolve) { return function (signupFields) {
        return resolve(signupFields);
    }; });
    SignupAction.onSignupCloseClick = typesafe_actions_1.createAction(SignupAction.ON_SIGNUP_CLOSE_CLICK, function (resolve) { return function () {
        return resolve();
    }; });
    SignupAction.onSignupLoginClick = typesafe_actions_1.createAction(SignupAction.ON_SIGNUP_LOGIN_CLICK, function (resolve) { return function () {
        return resolve();
    }; });
    SignupAction.togglePanelActive = typesafe_actions_1.createAction(SignupAction.TOGGLE_SINGUP_PANEL_ACTIVE, function (resolve) { return function () {
        return resolve();
    }; });
    SignupAction.setPanelActive = typesafe_actions_1.createAction(SignupAction.SET_SINGUP_PANEL_ACTIVE, function (resolve) { return function (state) {
        return resolve(state);
    }; });
    SignupAction.setPanelDim = typesafe_actions_1.createAction(SignupAction.SET_SINGUP_PANEL_DIM, function (resolve) { return function (state) {
        return resolve(state);
    }; });
    SignupAction.setLoading = typesafe_actions_1.createAction(SignupAction.SET_SIGNUP_LOADING, function (resolve) { return function (state) { return resolve(state); }; });
    SignupAction.setGlobalError = typesafe_actions_1.createAction(SignupAction.SET_SIGNUP_GLOBAL_ERROR, function (resolve) {
        return function (errorMessage) { return resolve(errorMessage); };
    });
})(SignupAction || (SignupAction = {}));
exports.default = SignupAction;
